import { Component, OnInit, AfterViewInit } from '@angular/core';
import { UnsubscribeComponent } from '../unsubscribe/unsubscribe.component';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { DownloadTermsConditionsService } from 'src/app/services/download-terms-conditions.service';

@Component({
  standalone: false,
  selector: 'app-modal-terms',
  templateUrl: './modal-terms.component.html',
  styleUrls: ['./modal-terms.component.scss']
})
export class ModalTermsComponent implements OnInit, AfterViewInit {

  showButton: boolean;
  showLiteral: boolean;
  contratacion: boolean;
  language: string;
  country: string;
  tyc: any;
  showHeaderFooter: boolean;
  signin: any;
  justShow: boolean;
  constructor(
    private modal: MatDialog,
    private route: ActivatedRoute,
    private readonly r: Router,
    private readonly t: DownloadTermsConditionsService,
    private activatedRoute: ActivatedRoute
  ) { 
    this.country = this.route.snapshot.paramMap.get('country') || 'ES';
    this.language = sessionStorage.getItem('language');
  }

  ngOnInit() {
    this.signin = this.activatedRoute.snapshot.queryParams.signin;
    this.tyc = sessionStorage.getItem('tyc');
    this.showLiteral = sessionStorage.getItem('polity') ? true : false;
    this.showButton = sessionStorage.getItem('terms') ? false : true;
    this.justShow = this.activatedRoute.snapshot.queryParams.show ? true : false;
    this.contratacion = !!JSON.parse(sessionStorage.getItem('getParams'));
    const getParams = JSON.parse(sessionStorage.getItem('getParams'));
    if (getParams) {
      this.showHeaderFooter = getParams[0] !== '3';
    } else {
      this.showHeaderFooter = true;
    }
  }

  ngAfterViewInit(): void { }

  openUnSubscribeModal() {
    const modalConfig = new MatDialogConfig();
    modalConfig.width = '95%';
    modalConfig.id = 'unsubscription';
    modalConfig.minWidth = '300px';
    modalConfig.maxWidth = '30vw';
    modalConfig.minHeight = '150px';
    const closedModal = this.modal.open(UnsubscribeComponent, modalConfig);
  }

  backView = () => {
    this.deleteTermsAndPolity();
  }

  /**
   * borra las variables de sesion
   */
  deleteTermsAndPolity = () => {
    sessionStorage.removeItem('polity');
    sessionStorage.removeItem('terms');
    if (this.isExist() && !sessionStorage.getItem('signinSCF')) {
      this.r.navigateByUrl('signin');
    } else if (sessionStorage.getItem('signinSCF')) {
      this.r.navigateByUrl('terms?scf=true');
    } else {
      window.history.back();
    }
  }

  agreeTerms() {
    sessionStorage.setItem('terms', '1');
    this.isEngagement();
    if (this.isExist() && !this.showLiteral) {
      sessionStorage.setItem('login_polity', '1');
      this.r.navigateByUrl((this.country) + '/' + 'privacy-polity');
    }
    if (this.isExist() && this.showLiteral && !sessionStorage.getItem('signinSCF')) {
      this.r.navigateByUrl('signin');
    } else if (!this.isExist() && this.showLiteral && !sessionStorage.getItem('signinSCF')) {
      this.r.navigateByUrl('terms');
    } else if (sessionStorage.getItem('signinSCF')) {
      this.r.navigateByUrl('signinSCF');
    }

    if (!this.isExist() && !this.showLiteral) {
      this.r.navigateByUrl((this.country) + '/' + 'privacy-polity');
    }
  }

  isExist = () => {
    return sessionStorage.getItem('form_sign') || sessionStorage.getItem('form_sign') === 'undefined' || sessionStorage.getItem('form_sign') === 'null';
  }

  isEngagement() {
    const aux = sessionStorage.getItem('getParams');
    const getParams = JSON.parse(aux);
    if (getParams) {
      sessionStorage.setItem('auxParam', aux);
    }
  }

  buildOtherTCUrl(isSignin: boolean): string {
    const param = isSignin ? '?signin=true&show=true' : '?show=true';
    const url = this.r.serializeUrl(
      this.r.createUrlTree(['terms-conditions'])
    );

    return window.location.origin + window.location.pathname + '#' + url + param;
  }

  downloadTerms(file?: any) {
    this.t.downloadTYC(file).subscribe(data => this.downloadFile(data));
  }

  downloadFile(data: ResponseType) {

    const blob = new Blob([data], { type: 'application/pdf' });
    const fileName = 'Terminos y condiciones';
    const objectUrl: string = URL.createObjectURL(blob);
    const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;

    a.href = objectUrl;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();

    document.body.removeChild(a);
    URL.revokeObjectURL(objectUrl);
  }

  openOtherTC(isSignin): void {
    window.open(this.buildOtherTCUrl(isSignin), '_blank');
  }


}
